<template>
  <v-expansion-panels class="secretarias" accordion focusable v-model="panel">
    <v-card width="100%">
      <h2 class="secretaria">Secretarias</h2>
      <template v-if="secretarias.length > 0">
        <v-expansion-panel
          v-for="(secretaria, index) in secretarias"
          :key="index"
        >
          <div>
            <v-expansion-panel-header>
              {{ secretaria.nomeSecretaria || "Nova Secretaria" }}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-col>
                <v-text-field
                  v-model="secretaria.nomeSecretaria"
                  label="Nome da secretaria"
                >
                </v-text-field>
              </v-col>

              <v-col>
                <v-text-field
                  v-model="secretaria.nomeResponsavel"
                  label="Nome do responsável"
                >
                </v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                  v-model="secretaria.emailResponsavel"
                  label="Email do responsável"
                >
                </v-text-field>
              </v-col>

              <v-col class="d-flex justify-end">
                <v-btn color="error" @click="remover(secretaria)"
                  >Remover Secretaria</v-btn
                >
              </v-col>
            </v-expansion-panel-content>
          </div>
        </v-expansion-panel>
      </template>
      <div class="d-flex justify-center mr-3 mb-3" v-else>
        Nenhuma secretaria encontrada
      </div>
      <div class="d-flex justify-end mr-3 mb-3 mt-3">
        <v-btn color="primary" @click="addSecretaria()">+ Secretaria</v-btn>
      </div>
    </v-card>
  </v-expansion-panels>
</template>
<script>
import { citySecretariaAPI } from "@/modules/city/API/CitySecretariaAPI";
import Swal from "sweetalert2";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "Secretaria",
  props: ["filter", "municipioId"],
  beforeMount() {
    this.getSecretariasMunicipio();
  },

  methods: {
    ...mapActions(["setLoading"]),

    addSecretaria() {
      this.secretarias.push({
        nomeSecretaria: "",
        nomeResponsavel: "",
        emailResponsavel: "",
        municipioId: this.municipioId,
      });

      this.panel = this.secretarias.length - 1;
    },
    remover(secretaria) {
      Swal.fire({
        title: "Remover Secretaria",
        text: `Deseja remover a secretaria do município?`,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Não",
        confirmButtonText: "Sim",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          if (secretaria.municipioSecretariaId) {
            this.setLoading(true);
            citySecretariaAPI
              .delete(secretaria.municipioSecretariaId)
              .then((_) => {
                this.setLoading(false);
              })
              .catch((err) => {
                this.setLoading(false);
                console.log("ERROR Secretaria remover --> ", err);
                this.$notification.error("Erro ao remover secretaria");
              });
          }
          this.secretarias.splice(this.secretarias.indexOf(secretaria), 1);
        }
      });
    },
    getSecretariasMunicipio() {
      citySecretariaAPI
        .findByMunicipio(this.municipioId)
        .then(({ data }) => {
          console.log("data: ", data);
          this.secretarias = data;
        })
        .catch((err) => {
          console.log("ERROR Secretaria getSecretariasMunicipio --> ", err);
          this.$notification.error("Erro ao obter secretarias");
        });
    },
    salvarTodas() {
      citySecretariaAPI
        .cadastrarMultiplos(this.secretarias)
        .then((_) => {})
        .catch((err) => {
          console.log("ERROR Secretaria salvarTodas --> ", err);
          this.$notification.error("Erro ao salvar secretarias");
        });

      this.panel = null;
    },
  },
  data() {
    return {
      secretarias: [],
      panel: null,
    };
  },
};
</script>
<style lang="scss">
.secretarias {
  .v-expansion-panel-header {
    background: #0000001c;
    border-bottom: 1px solid #fff;
  }

  .v-expansion-panel--active:not(:first-child) {
    margin: 0;
  }
}
</style>
<style lang="scss" scoped>
.secretaria {
  font-size: 16px;
  padding: 10px 15px;
  font-weight: 500;
}
</style>
